const Resources = () => {
  const items = [
    {
      emoji: '▶️',
      label: 'Get Started Guide',
      description: 'Watch this short video to get started with classrooms, pathways, and tutors.',
      href: 'https://coda.io/d/Frequently-Asked-Questions_dazL7wOvRR3/Getting-started-on-Mindjoy_suq4uKvs'
    },
    {
      emoji: '📚',
      label: 'Pathways',
      description: 'Build beautiful learning progressions that motivate and guide students.',
      href: 'https://coda.io/d/Frequently-Asked-Questions_dazL7wOvRR3/Pathways_suvE8oxY'
    },
    {
      emoji: '🤖',
      label: 'Tutors',
      description: 'Build AI tutors that develop learners\' curiosity, critical thinking, and motivation.',
      href: 'https://coda.io/d/Frequently-Asked-Questions_dazL7wOvRR3/AI-Tutors_suIPaKVq'
    },
    {
      emoji: '📆',
      label: 'Events',
      description: 'See our upcoming events and workshops.',
      href: 'https://lu.ma/calendar/cal-bIw7gsI4KC1cfVo/events'
    }
  ]

  return (
    <div className='flex flex-col sm:flex-row md:flex-col gap-3'>
      <For each='item' of={items}>
        <a href={item.href} target='_blank' className='p-5 border rounded-lg'>
          <h4 className='text-sm font-semibold my-1'>
            {item.emoji}&nbsp;{item.label}
          </h4>
          <p className='text-sm text-muted-foreground'>
            {item.description}
          </p>
        </a>
      </For>
    </div>
  )
}

export default Resources
